import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import type { CreateLinkFormProps, CreateLinkModalProps } from "./types";
import {
  isValidHref,
  normaliseHref,
} from "../../../formatting/sanitise-rich-text";

function CreateLinkForm({
  initialHref,
  onCancel,
  onSave,
  onRemove,
}: CreateLinkFormProps) {
  const [href, setHref] = useState(initialHref);
  const normalisedHref = normaliseHref(href);
  const hasError = Boolean(href.trim()) && !isValidHref(normalisedHref);

  return (
    <>
      <DialogTitle>{initialHref ? "Edit link" : "Add link"}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          margin="dense"
          label="Link URL"
          value={href}
          error={hasError}
          helperText={hasError ? "Enter an https link" : "Enter a link"}
          onChange={(event) => setHref(event.target.value)}
          onKeyDown={(event) => {
            if (event.key !== "Enter" || hasError || !normalisedHref) return;
            event.preventDefault();
            onSave(normalisedHref);
          }}
        />
      </DialogContent>
      <DialogActions>
        {initialHref ? (
          <Button color="error" onClick={onRemove}>
            Remove link
          </Button>
        ) : null}
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          variant="contained"
          disabled={hasError || !normalisedHref}
          onClick={() => onSave(normalisedHref)}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
}

function CreateLinkModal({
  open,
  initialHref,
  onCancel,
  onSave,
  onRemove,
}: CreateLinkModalProps) {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      {open ? (
        <CreateLinkForm
          key={initialHref}
          initialHref={initialHref}
          onCancel={onCancel}
          onSave={onSave}
          onRemove={onRemove}
        />
      ) : null}
    </Dialog>
  );
}
export default CreateLinkModal;
